import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../types';
import { useCurrency } from '../context/CurrencyContext';

interface Props {
  product: Product;
}

const ProductCard: React.FC<Props> = ({ product }) => {
  const { formatPrice } = useCurrency();
  const hasDiscount = product.discount_price !== null;
  const displayPrice = hasDiscount ? product.discount_price : product.price;

  return (
    <Link to={`/product/${product.slug}`} className="product-card">
      <div className="product-card-image">
        <img src={product.image} alt={product.name} />
        {hasDiscount && <span className="sale-badge">Sale</span>}
        {!product.in_stock && <span className="sold-out-badge">Sold Out</span>}
      </div>
      <div className="product-card-info">
        <p className="product-card-category">{product.category_name}</p>
        <h3 className="product-card-name">{product.name}</h3>
        <div className="product-card-price">
          <span className="current-price">{formatPrice(displayPrice!)}</span>
          {hasDiscount && <span className="original-price">{formatPrice(product.price)}</span>}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
